export default function BloodType() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <g clip-path="url(#clip0_477_2146)">
        <path
          d="M11.5 23.5C9.1682 23.5 7.0291 22.687 5.47673 21.2108C3.82938 19.6443 2.95862 17.4916 2.95862 14.9854C2.95862 12.8492 4.29523 9.79932 6.93133 5.92034C8.84591 3.10305 10.7299 0.904612 10.8091 0.812422C11.1671 0.395888 11.8329 0.395831 12.1909 0.812422C12.238 0.867258 13.361 2.17665 14.7569 4.0701L13.2902 5.15133C12.71 4.36487 12.1123 3.59153 11.4974 2.83189C9.13159 5.74148 4.78078 11.7591 4.78078 14.9854C4.78078 18.9258 7.5438 21.6778 11.5 21.6778C15.4562 21.6778 18.2192 18.9258 18.2192 14.9854C18.2192 13.9735 17.765 12.0343 15.6011 8.54249L17.1499 7.58272C19.0685 10.6786 20.0413 13.1693 20.0413 14.9855C20.0413 17.4916 19.1706 19.6443 17.5232 21.2109C15.9709 22.687 13.8318 23.5 11.5 23.5Z"
          fill="#959595"
        />
        <path
          d="M14.9218 7.48198C14.6485 7.06882 14.3694 6.65955 14.0845 6.2543L15.5755 5.20679C15.8704 5.62625 16.1593 6.04989 16.4422 6.47757L14.9218 7.48198ZM12.3392 9.43528H10.6484L7.7464 17.9767H9.48223L10.3025 15.4923H12.6406L13.4843 17.9767H15.2538L12.3392 9.43528ZM12.2168 14.0525H10.7231C10.901 13.5025 11.2249 12.4978 11.4667 11.7269C11.7094 12.4928 12.0368 13.5003 12.2168 14.0525Z"
          fill="#959595"
        />
      </g>
      <defs>
        <clipPath id="clip0_477_2146">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
